module.exports = __webpack_public_path__ + "img/icon_forecast@2x.3576cbef.png";